<template>
  <div class="drugPrice column-me">
    <div class="card-div column-me flex1">
      <div class="btn-blue width160 btn-height40" @click="clickAdd()" v-if="canOperate">
        <el-icon>
          <plus/>
        </el-icon>
        新增药价方案
      </div>
      <div class="margin-top20">
        <el-table :data="tableData" border header-cell-class-name="table-header-style"
                  cell-class-name="table-cell-style" height="75vh">
          <el-table-column prop="name" label="分类名称" align="center"></el-table-column>
          <el-table-column prop="discount" label="零售折扣" align="center"></el-table-column>
          <el-table-column prop="note" label="备注" align="center"></el-table-column>
          <el-table-column label="操作列" align="center" width="280">
            <template #default="scope">
              <div class="row-me center-all">
                <div class="btn-blue width100 btn-height40" @click="clickDetail(scope.row)">
                  <img src="../../assets/img/detail.png" class="img-icon">
                  详情
                </div>
                <div class="btn-grey width100 btn-height40 margin-left20"
                     @click="clickDelete(scope.row)" v-if="canOperate">
                  <el-icon>
                    <delete/>
                  </el-icon>
                  删除
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>


    <!-- 新增药价方案 -->
    <el-dialog title="新增药价方案" v-model="visible" width="40%" top="10vh" :destroy-on-close="true">
      <div class="dialog-content">
        <div class="row-me row-center">
          <div><span class="red-star">*</span>方案名称：</div>
          <div class="flex1 margin-left5">
            <el-input placeholder="请输入方案名称" style="width: 100%;" clearable v-model="selectItem.name"
                      :class="{'red-border':showRedBorder&&this.$method.isEmpty(selectItem.name)}"
                      maxlength="50">
            </el-input>
          </div>
        </div>
        <div class="row-me row-center margin-top20">
          <div><span class="red-star">*</span>零售折扣：</div>
          <div class="flex1 margin-left5">
            <el-input placeholder="请输入零售折扣" style="width: 100%;" clearable v-model="selectItem.discount"
                      :class="{'red-border':showRedBorder&&this.$method.isEmpty(selectItem.discount)}"
                      @input="selectItem.discount=$method.checkInput(selectItem.discount,2)"></el-input>
          </div>
        </div>
        <div class="row-me margin-top20">
          <div class="width85 text-justify"><span class="red-star-div"></span>备注</div>
          <div>：</div>
          <div class="flex1 margin-left5">
            <el-input placeholder="请输入备注" type="textarea" style="width: 100%;" clearable
                      v-model="selectItem.note" maxlength="200">
            </el-input>
          </div>
        </div>
        <div class="row-me row-center flex-end1 margin-top200">
          <div class="btn-blue width140 btn-height40" @click="clickSave">保存</div>
          <div class="btn-grey width140 btn-height40 margin-left20" @click="clickCancel">取消</div>
        </div>
      </div>
    </el-dialog>


    <!-- 方案详情 -->
    <el-dialog title="方案详情" v-model="visibleDetail" :width="1265" top="10vh" :destroy-on-close="false">
      <div class="padding10">
        <div class="row-me row-center">
          <div class="btn-blue width220 btn-height40 margin-right20" @click="clickPrice1" v-if="canOperate">批量修改常规剂型销售价
          </div>
          <div class="btn-blue width220 btn-height40 margin-right20" @click="clickPrice2" v-if="canOperate">
            批量修改颗粒剂型销售价
          </div>
          <div class="btn-orange width140 btn-height40 margin-right20" @click="clickExport">导出</div>
          <div class="flex1"></div>
          <div class="width180">
            <el-input placeholder="请输入药品名称" style="width: 100%;" clearable v-model="searchName"></el-input>
          </div>
          <!--v27隐藏-->
          <div class="width180 margin-left20" v-if="false">
            <el-select placeholder="药品类型" style="width: 100%;" filterable clearable v-model="selectType">
              <el-option v-for="item in [{id:0,name:'中药处方'},{id:1,name:'中医外治'}]" :key="item.id"
                         :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="btn-blue width100 btn-height40 margin-left20" @click="clickSearch">
            <el-icon>
              <search/>
            </el-icon>
            查询
          </div>
          <div class="btn-blank width100 btn-height40 margin-left20" @click="clickClear" v-if="false">清空</div>
        </div>
        <div class="margin-top20">
          <el-table-v2 :columns="columns" :data="tableDataDetail" :width="1200" :height="600"
                       header-class="table-header-style" row-class="table-cell-style">
          </el-table-v2>

        </div>
      </div>
    </el-dialog>


    <!-- 批量修改常规批发价（批量修改颗粒批发价） -->
    <el-dialog :title="drugPriceTitle" v-model="visibleDrugPrice" width="40%" top="20vh" :destroy-on-close="true">
      <div class="padding20">
        <div class="row-me row-center">
          <div><span class="red-star">*</span>修改方式：</div>
          <el-radio-group v-model="selectWay">
            <el-radio :label="0">按比例</el-radio>
            <el-radio :label="1">按固额</el-radio>
          </el-radio-group>
        </div>
        <div class="row-me row-center margin-top30" v-if="selectWay===0">
          <div><span class="red-star">*</span>按比例：</div>
          <div class="width200">
            <el-input placeholder="请输入" style="width: 100%;" v-model="rate" type="number" min="0"
                      @input="rate=$method.checkInput(rate,3)"
                      :class="{'red-border':showRedBorder&&this.$method.isEmpty(rate)}">
            </el-input>
          </div>
          <div class="margin-left10 margin-right30">%</div>
          <el-radio-group v-model="rateRadio">
            <el-radio :label="0">上浮</el-radio>
            <el-radio :label="1">下降</el-radio>
          </el-radio-group>
        </div>
        <div class="row-me row-center margin-top30" v-if="selectWay===1">
          <div><span class="red-star">*</span>按固额：</div>
          <div class="width300">
            <el-input placeholder="请输入" style="width: 100%;" v-model="money" type="number" min="0"
                      @input="money=$method.checkInput(money,3)"
                      :class="{'red-border':showRedBorder&&this.$method.isEmpty(money)}"></el-input>
          </div>
          <div class="margin-left10 margin-right30">元</div>
        </div>
        <div class="row-me row-center flex-end1 margin-top200">
          <div class="btn-blue width140 btn-height40" @click="clickSave1">保存</div>
          <div class="btn-grey width140 btn-height40 margin-left20" @click="clickCancel1">取消</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {unref} from "vue";

export default {
  components: {},
  data() {
    return {
      tableData: [],
      visible: false,
      selectItem: {
        name: '',
        discount: '',
        note: '',
      },
      showRedBorder: false,
      visibleDetail: false,
      tableDataDetail: [],
      visibleDrugPrice: false,
      selectWay: 0, //	修改方式 0 按比例 1 固额
      rate: '',
      rateRadio: 0, //上下浮动 0 上浮 1下降
      money: '',
      drugPriceTitle: '',
      multipleSelection: [],
      searchName: '',
      selectType: '',
      target: '', //类型 0 修改常规销售价 1 修改颗粒销售价
      canOperate: false,
      columns: [],
    }
  },
  // html加载完成之前
  created() {
    this.$getMenuOperateAuth(this.$route.path).then(res => {
      this.canOperate = res.data
    })
    this.getData()
    this.columns = [
      {
        key: 'selection',
        width: 50,
        cellRenderer: ({rowData}) => {
          const onChange = (value) => (rowData.checked = value)
          return <el-checkbox modelValue={rowData.checked} onChange={onChange}>< /el-checkbox>
        },
        headerCellRenderer: () => {
          const _data = unref(this.tableDataDetail)
          const onChange = (value) =>
              (this.tableDataDetail = _data.map((row) => {
                row.checked = value
                return row
              }))
          const allSelected = _data.every((row) => row.checked)
          const containsChecked = _data.some((row) => row.checked)
          this.multipleSelection = _data.filter(row => {
            return row.checked
          })
          return <el-checkbox modelValue={allSelected} indeterminate={containsChecked && !allSelected}
                              onChange={onChange}>< /el-checkbox>
        },
      },
      {key: 'name', dataKey: 'name', title: '药品名', align: 'center', width: 240},
      {key: 'normalPrice', dataKey: 'normalPrice', title: '参考常规剂型批发价', align: 'center', width: 240},
      {key: 'schemeNormalPrice', dataKey: 'schemeNormalPrice', title: '常规剂型销售价', align: 'center', width: 240},
      {key: 'granulePrice', dataKey: 'granulePrice', title: '参考颗粒剂型批发价', align: 'center', width: 240},
      {key: 'schemeGranulePrice', dataKey: 'schemeGranulePrice', title: '颗粒剂型销售价', align: 'center', width: 240},
    ]
  },
  // html加载完成后执行。
  mounted() {

  },
  // 事件方法执行
  methods: {
    //新增
    clickAdd() {
      this.selectItem = {
        name: '',
        discount: '',
        note: '',
      }
      this.showRedBorder = false
      this.visible = true
    },
    //详情
    clickDetail(item) {
      this.selectItem = this.$method.deepClone(item)
      this.getDetail()
      this.visibleDetail = true
    },
    //删除
    clickDelete(item) {
      this.$confirm("您确定要删除吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$postFormRequest('/admin/scheme/delScheme', {
          id: item.id
        }).then((res) => {
          if (res) {
            this.$message.success(res.message)
            this.getData()
          }
        }).catch((error) => {
          console.log(error)
        })
      }).catch(() => {
      });
    },
    //搜索
    clickSearch() {
      this.getDetail()
    },
    //清空
    clickClear() {
      this.searchName = ''
      this.getDetail()
    },
    //保存
    clickSave() {
      if (this.$method.isEmpty(this.selectItem.name) || this.$method.isEmpty(this.selectItem.discount)) {
        this.showRedBorder = true
        return
      }
      this.$postRequest('/admin/scheme/saveScheme', this.selectItem).then((res) => {
        if (res) {
          this.$message.success(res.message)
          this.visible = false
          this.getData()
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //取消
    clickCancel() {
      this.visible = false
    },
    //批量修改常规剂型销售价
    clickPrice1() {
      if (this.multipleSelection.length === 0) {
        this.$message.error('请先选择药品')
        return
      }
      this.target = 0
      this.selectWay = 0
      this.rate = ''
      this.rateRadio = 0
      this.money = ''
      this.drugPriceTitle = '批量修改常规剂型销售价'
      this.showRedBorder = false
      this.visibleDrugPrice = true
    },
    //批量修改颗粒剂型销售价
    clickPrice2() {
      if (this.multipleSelection.length === 0) {
        this.$message.error('请先选择药品')
        return
      }
      this.target = 1
      this.selectWay = 0
      this.rate = ''
      this.rateRadio = 0
      this.money = ''
      this.drugPriceTitle = '批量修改颗粒剂型销售价'
      this.showRedBorder = false
      this.visibleDrugPrice = true
    },
    //导出
    clickExport() {
      let token = sessionStorage.getItem('token')
      let url = this.$baseUrl + '/admin/scheme/brDrugSchemeExport?id=' + this.selectItem.id + '&token=' + token
      window.open(url)
    },
    //保存
    clickSave1() {
      if ((this.selectWay === 0 && this.$method.isEmpty(this.rate))
          || (this.selectWay === 1 && this.$method.isEmpty(this.money))) {
        this.showRedBorder = true
        return
      }
      let ids = []
      for (let item of this.multipleSelection) {
        ids.push(item.id)
      }
      let param;
      if (this.selectWay === 0) { //按比例
        param = {
          type: this.target,
          updateMethod: this.selectWay,
          price: this.rate,
          volatility: this.rateRadio,
        }
      } else if (this.selectWay === 1) { //按固额
        param = {
          type: this.target,
          updateMethod: this.selectWay,
          price: this.money,
        }
      }
      param.ids = ids
      this.$postRequest('/admin/scheme/batchUpdatePrice', param).then((res) => {
        if (res) {
          this.$message.success(res.message)
          this.visibleDrugPrice = false
          for (let item of this.tableDataDetail) {
            item.checked = false
          }
          this.multipleSelection = []
          this.getDetail()
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //取消
    clickCancel1() {
      this.visibleDrugPrice = false
    },
    //获取数据
    getData() {
      this.$getRequest('/admin/scheme/page', {}).then((res) => {
        if (res) {
          this.tableData = res.data
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //获取详情
    getDetail() {
      this.$getRequest('/admin/scheme/info', {
        id: this.selectItem.id,
        name: this.searchName,
        type: this.selectType,
      }).then((res) => {
        if (res) {
          for (let item of res.data) {
            item.checked = false
          }
          this.tableDataDetail = res.data
        }
      }).catch((error) => {
        console.log(error)
      })
    },
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
}
</script>

<style lang="scss" scoped>
.drugPrice {
  height: 100%;

  .card-div {
    margin: 20px;
    background: #FFFFFF;
    box-shadow: 0 0 5px #F3F3F3;
    border-radius: 3px;
    padding: 20px;
    overflow: auto;
  }

  .dialog-content {
    padding: 10px;

    .title1 {
      width: 100px;
      text-align: justify;
      text-align-last: justify;
    }
  }
}
</style>
